/**
 * Created by: cparaschiv
 * Date: 02.04.2013, 15:51
 */

(function () {
    'use strict';

    var uidCleanRe = new RegExp("-", "g");

    /**
     * @class TS.domain.RecordListDomain
     * @extends TS.domain.Domain
     */
    TS.domain.RecordListDomain = new Class(
        /** @lends TS.domain.Domain# */
        {
            Extends: TS.domain.Domain,

            mapping: $.extend(TS.domain.Domain.prototype.mapping, {
                ignore: TS.domain.Domain.prototype.mapping.ignore.concat(['Fields', 'Filters']),
                copy: TS.domain.Domain.prototype.mapping.copy.concat(['sort', 'defaultFiltersValues', 'showEditLinks', 'AllowMultipleSelection', 'PrimaryKeys', 'FilterDependencies', 'SelectedRows']),
                suppress: TS.domain.Domain.prototype.mapping.suppress.concat(['sort', 'defaultFiltersValues', 'showEditLinks', 'AllowMultipleSelection', 'PrimaryKeys', 'FilterDependencies', 'SelectedRows']),
            }),

            PageSize: 200,
            grid: null,
            rootUrl: '/',
            events: ['selectionChanged', 'itemSelected'],
            _filterDepSubscr: [],
            _browserModelDefaultFilters: null,


            _cmdHandlers: {
                'Record.New': 'newRecord',
                'Record.Edit': 'editRecord',
                'Record.Delete': 'deleteRecords',
                'Record.Refresh': 'refreshRecords',
                'Record.Close': 'close',

                'List.Export': 'exportRecords',
                'Filter.ApplyFilter': 'applyFilter',
                'Filter.Close': 'closeFilterForm',
                'Filter.ResetFilter': 'resetFilters'
            },

            initialize: function (config) {
                var me = this,
                    re = new RegExp("-", "g");

                me.parent(config);

                me.SelectedRows = [];

                me.cleanUID = config.modelUID.replace(uidCleanRe, "");
                me._filterForm();
                me._searchInput();
                me._searchStatus();

                this.yesNoChoices = ko.observableArray([
                    {id: "", name: TS.cultures.current.common.EmptySelection},
                    {id: "true", name: TS.cultures.current.common.Yes},
                    {id: "false", name: TS.cultures.current.common.No}
                ]);
            },

            initializeProperties: function (config) {
                var me = this;

                me.parent(config);

                me.createFields(config.Fields);
                me.createFilters(config.Filters);
            },

            getMappingOptions: function () {
                var result = this.parent();
                result.copy = (result.copy || []).concat();
                return result;
            },

            //region UI

            //region Filter

            _filterForm: function () {
                var me = this,
                    clickEventName = "click.RecordListDomain",
                    filterForm = me.filterFormElement = $('#search-box-' + me.cleanUID),
                    searchDropdown = me.searchDropdownElement = $("#searchDropdown-" + me.cleanUID);

                (function ($) {
                    $.each(['show', 'hide'], function (i, ev) {
                        var el = $.fn[ev];
                        $.fn[ev] = function () {
                            this.trigger(ev);
                            return el.apply(this, arguments);
                        };
                    });
                })(jQuery);

                filterForm.bind('show', function () {
                    $(document).bind(clickEventName, function (e) {
                        // In case of lookups there is a search input that when focused (by click) triggers the hide action
                        // We can ignore the click if there is an element that has the same aria-owns attribute inside the filter form
                        var ariaOwns = $(e.target).attr('aria-owns');
                        if (ariaOwns)
                            ariaOwns = filterForm.has('[aria-owns=' + ariaOwns + ']').length > 0;

                        if (!searchDropdown.is(e.target) &&
                            searchDropdown.has(e.target).length === 0 && !filterForm.is(e.target) &&
                            filterForm.has(e.target).length === 0 &&
                            filterForm.has(document.activeElement).length === 0 && !ariaOwns) {
                            filterForm.hide();
                            $(this).unbind(e);
                        }
                    });
                });

                filterForm.bind('hide', function () {
                    $(document).unbind(clickEventName);
                });
            },

            _searchInput: function () {
                var me = this,
                    keypressEventName = "keypress.RecordListDomain",
                    searchInput = me.searchInputElement = $("#fullTextSearchInput-" + me.cleanUID);

                if (searchInput) {
                    searchInput.unbind(keypressEventName);
                    searchInput.bind(keypressEventName, function (e) {
                        if (e.which == 13) {
                            searchInput.blur();
                            me.applyFilter();
                        }
                    });
                }
            },

            _searchStatus: function () {
                var me = this,
                    searchStatus = this.searchStatusElement = this.searchStatusElement || $("#search-box-status-" + me.cleanUID);

                if (searchStatus) {
                    var empty = true;
                    if (me.defaultFiltersValues) {
                        $.each(me.Filters, function (fltName, filter) {
                            if (fltName !== "FullTextSearch") {
                                var defaultValue = me.defaultFiltersValues[fltName];
                                if (empty === true && filter.Visible() === true && filter.Value() != defaultValue)
                                    empty = false;
                            }
                        });
                    }
                    searchStatus.toggleClass("filled", !empty);
                    searchStatus.toggleClass("empty", empty);
                }
            },

            //endregion

            //region GridList

            //region Switch to remote

            switchGridDatasourceToRemote: function () {
                var me = this;

                me.grid.dataSource.transport = new kendo.data.RemoteTransport({
                    read: {
                        url: (me.getRootUrl() || '') + "/GetListData"
                    },

                    parameterMap: function (options, type) {
                        if (type == "read") {
                            options.modelUID = me.modelUID;
                            return options;
                        }
                    },

                    success: me.handleSuccess,
                    error: me.handleError
                });
            },

            //endregion

            //region Grid Configuration

            getGridDefaults: function (cfg) {
                var me = this,
                    defaults;

                me.pageSizes = [10, 20, 50, 100];

                if (!me.pageSizes.contains(me.PageSize())) {
                    me.pageSizes.append([me.PageSize()]);
                    me.pageSizes.sort(function (a, b) {
                        return a - b
                    });
                }

                defaults = {
                    selectable: me.AllowMultipleSelection ? "multiple, row" : "row",
                    filterable: false,
                    resizable: true,
                    pageable: {
                        pageSize: me.PageSize(),
                        pageSizes: me.pageSizes, //false
                        previousNext: true,
                        numeric: true,
                        buttonCount: 5,
                        refresh: true,
                        info: false,
                        messages: TS.cultures.current.pagerMessages
                    },
                    dataSource: {
                        serverSorting: true,
                        serverPaging: true,
                        serverFiltering: true,
                        serverGrouping: true,
                        serverAggregates: true,
                        page: me.initData && me.initData.pageIndex || 1,
                        data: me.initData,
                        requestStart: me.requestStart,
                        requestEnd: me.requestEnd,
                        sort: me.sort,
                        schema: {
                            model: {
                                fields: {
                                    //checked: { type: "boolean" }
                                }
                            },
                            total: function (response) {
                                if (response.hasOwnProperty('totalCount'))
                                    return response.totalCount;

                                return me.TotalCount(); // trebuie luat din model, totalul initial
                            },
                            data: function (response) {
                                TS.makeDates(response);
                                return response.pageData || response;
                            }
                        }
                    }
                };
                Object.append(cfg, defaults);
            },

            getGridCellTemplate: function (field, isPopup) {
                return TS.UI.CellRenderer.getCellTemplate(field, isPopup);
            },

            getGridColumns: function () {
                var me = this,
                    columns = [],
                    groups = {};

                $.each(me.Fields, function (fieldIndex, field) {
                    if (field.IsList() === false)
                        return;

                    var fieldName = field.FieldName(),
                        addColumnTo = columns,
                        fieldLabel = field.Label();

                    var labels = fieldLabel.split('|');
                    if (labels.length > 1) {
                        labels.forEach(function (item, index) {
                            if (index < labels.length - 1) {
                                if (groups[item] === undefined) {
                                    groups[item] = {
                                        title: item,
                                        attributes: {
                                            style: "text-align: right;"
                                        },
                                        columns: []
                                    };
                                    columns.push(groups[item]);
                                }
                                addColumnTo = groups[item].columns;
                            } else {
                                fieldLabel = item;
                            }
                        });
                    }

                    addColumnTo.push({
                        field: fieldName,
                        title: fieldLabel,
                        width: field.Width() || 0,
                        resizable: true,
                        template: me.getGridCellTemplate(field, me.isPopup)
                    });
                });

                return columns;
            },

            getGridConfig: function () {
                var me = this,
                    ret = {
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    };

                me.getGridDefaults(ret);
                ret.columns = me.getGridColumns();
                return ret;
            },

            //endregion

            //region Grid Events

            onGridSelectionChanged: function (e) {
                var me = this,
                    g = me.grid,
                    selRows = g.select(),
                    rowIndex = g.rowIndex,
                    sel = [],
                    selItems = [],
                    indices = [],
                    dataItem,
                    i, idx,
                    page, pageSize,
                    selCmd, editCmd, deleteCmd;

                page = g.dataSource.page();
                pageSize = g.dataSource.pageSize();

                for (i = 0; i < selRows.length; i++) {
                    dataItem = g.dataItem(selRows[i]);
                    selItems.push(dataItem);
                    idx = rowIndex(selRows[i]);
                    idx = pageSize * (page - 1) + idx;
                    indices.push(idx);
                }

                me.SelectedRows = selItems;
                me.Selection(indices || []);

                selCmd = me.getCommand('Select.Select');
                if (selCmd) {
                    selCmd.Enabled(true);
                }

                editCmd = me.getCommand('Record.Edit');
                if (editCmd) {
                    editCmd.Enabled(true);
                }

                deleteCmd = me.getCommand('Record.Delete');
                if (deleteCmd) {
                    deleteCmd.Enabled(true);
                }

                me.fireEvent('selectionChanged', sel);
            },

            onGridRowDoubleClick: function (e) {

                if (e.target.tagName === 'A' && e.target.className === 'select-link') {
                    return false;
                }

                var me = this;
                me.executeDefaultCommand();
                /*
                 if (!me.isPopup) {
                 me.executeCommand('Record.Edit');
                 //me.editRecord();
                 } else {
                 me.confirmSelection();
                 }*/
            },

            onGridRowLinkClick: function (e) {
                var me = this,
                    handler, tr;

                if (me.isPopup) {
                    if (e.target) {
                        tr = $(e.target).parents('tr').get(0);
                        if (tr) {
                            // prepare for selectionChanged event
                            handler = function (sel) {
                                me.un('selectionChanged', handler);
                                //me.confirmSelection();
                                me.executeDefaultCommand();
                            };
                            me.on('selectionChanged', handler);

                            // instruct grid to select parent element (will trigger the event)
                            me.grid.select(tr);
                        }
                    }
                }
            },


            //endregion

            updateGridSelection: function () {
                //me.grid.select("tr[data-uid='" + uid + "']");
            },

            configureGrid: function (selector) {

                var me = this,
                    cfg = me.getGridConfig(),
                    gridEl;

                cfg.pageable.refresh = false;
                gridEl = $(selector).kendoGrid(cfg);
                me.grid = gridEl.data('kendoGrid');

                me.grid._progress = function () {
                };
                kendo.ui.progress = function () {
                };

                me.grid.wrapper.addClass('ts-grid-list');
                me.grid.rowIndex = function (tr) {
                    return $(tr).parent().children('tr').index(tr);
                };

                // kendo event - use bind
                me.grid.bind("change", $.proxy(me.onGridSelectionChanged, me));
                // initial data was read, for further information it should be fetched from server
                me.switchGridDatasourceToRemote();

                // handle row double-clicks
                // DOM event, use jQuery's 'on'
                $(selector).on("dblclick", "tbody>tr", $.proxy(me.onGridRowDoubleClick, me));

                if (me.isPopup) {
                    $(selector).on("click", "tbody>tr>td a", $.proxy(me.onGridRowLinkClick, me));
                }
                else {
                    $(selector).on("click", "tbody>tr>td a", me.requestStart);
                }
            },

            //endregion

            //endregion

            //region Fields

            createFields: function (config) {
                var me = this;
                $.each(config, function (index, field) {
                    field.IsList = field.IsList !== false;
                });
                me.Fields = ko.mapping.fromJS(config)();
                delete me.Fields.__ko_mapping__;
                me.makeEditLink();
            },

            makeEditLink: function () {
                var me = this,
                    visibleIndex = 0;
                if (me.showEditLinks !== false) {
                    $.each(me.Fields, function (index, field) {
                        field.IsList() && (++visibleIndex) && (field.isEditLink = visibleIndex <= 3);
                    });
                }
            },

            //endregion

            //region Filters

            createFilters: function (config) {
                var me = this;
                me.Filters = ko.mapping.fromJS(config, {copy: ['type']});
                delete me.Filters.__ko_mapping__;

                $.each(me.Filters, function (filterName, filter) {
                    //FullTextSearch should not have value
                    filterName === 'FullTextSearch' && filter.Value(null);

                    me.watch("Filters." + filterName + ".Value", me, function () {
                        me._searchStatus();
                        if (me.FilterDependencies[filterName]) {
                            var destination = me.Filters[me.FilterDependencies[filterName]],
                                property = me.getDomainProperty('FilterItem_' + dst + '_Property');

                            destination && destination.Value(null);
                            if (property) {
                                property.selectedItem({});
                                property.selectedIndex(-1);
                                property.Value = null;
                                property.invalidateList();
                                property.reset();
                            }
                        }
                    });
                });

                me.FilterDependencies = {};
            },

            updateFilters: function (config) {
                var me = this;

                $.each(config, function (filterName, filterConfig) {
                    var filter = me.Filters[filterName];
                    if (filter) {
                        filter.Value(filterConfig.Value);
                    }
                });
            },

            //endregion

            //region Command Handlers

            newRecord: function () {
                var me = this,
                    url = me.getRootUrl();

                TS.trace('newRecord');
                url += 'Add';
                TS.UI.navigateTo(url);
            },

            editRecord: function () {
                var me = this,
                    url = me.getRootUrl();

                //validate selection first
                if (!TS.isDefined(me.SelectedRows) || me.SelectedRows.length < 1) {
                    TS.Notify.info(TS.cultures.current.list.NoRecordSelected);
                    return;
                }

                var firstItem = me.SelectedRows[0];
                // data items might have editLink rendered by server, use it
                if (firstItem.editLink) {
                    url += firstItem.editLink;
                }
                // fallback: try to extract primary keys and build url
                else {
                    var pkValues = me.extractPkValues(me.SelectedRows);
                    if (!pkValues || pkValues.length < 1) {
                        TS.Notify.error('Cannot extract primary keys from selection');
                        return;
                    }
                    url += 'Edit?';
                    url += $.param(pkValues[0]);
                }

                TS.UI.navigateTo(url);

                me.requestStart();
            },

            deleteRecords: function () {
                var me = this,
                    strings = TS.cultures.current;

                if (me.SelectedRows.length < 1) {
                    TS.Notify.info(TS.cultures.current.list.NoRecordSelected);
                    return;
                }

                TS.MsgBox.confirm(null, strings.list.DeleteSelectedRecords, strings.common.Delete, function () {
                    me.performServerCommand({
                        cmd: 'Delete',
                        submitModel: true,
                        extraData: {confirmed: true},
                        callback: function (response) {
                            me.grid.dataSource.read();
                        }
                    });
                });
            },
            
            refreshRecords: function () {
                this.grid.dataSource.read();
                this.SelectedRows = [];
                this.Selection([]);
            },


            applyFilter: function (resetFullText) {
                var me = this,
                    fullTextSearch = me.Filters["FullTextSearch"];

                //wait for all bindings to complete
                setTimeout(function () {
                    fullTextSearch && (TS.domain.RecordListDomain.resetFullTextSearchOnFilter || resetFullText) && fullTextSearch.Value(null);
                    me.performServerCommand("Filter.ApplyFilter", true, {refresh: false}, function () {
                        me.filterFormElement.hide(600);
                        me.grid.dataSource.page(0);
                    });
                }, 10);
            },

            resetFilters: function () {
                var me = this;

                if (me.Filters && me.defaultFiltersValues) {
                    $.each(me.Filters, function (fltName, filter) {
                        if (fltName !== "FullTextSearch") {
                            var initFilterValue = me.defaultFiltersValues[fltName];
                            if (typeof initFilterValue !== 'undefined')
                                filter.Value(initFilterValue);
                        }
                    });
                }
            },

            closeFilterForm: function () {
                me.filterFormElement.hide();
            },

            exportRecords: function () {
                var me = this;
                TS.UI.navigateTo(me.rootUrl + '/ExportData');
            },

            //endregion

            //region Helpers

            extractPkValues: function (sel) {
                var me = this,
                    result = [];

                $.each(TS.unwrap(sel), function (index, item) {
                    var pks = {};
                    $.each(me.PrimaryKeys, function (fieldIndex, fieldName) {
                        pks[fieldName] = item[fieldName];
                    });
                    result.push(pks);
                });

                return result;
            },

            confirmSelection: function () {
                var me = this;
                TS.trace('Selection confirmed!');
                if (me.getCommand("Select.PopupSelect") !== null) {
                    me.fireEvent('itemSelected', me.SelectedRows);
                }
                else {
                    me.performServerCommand({
                        cmd: 'Select.Select',
                        submitModel: true,
                        callback: function () {
                            me.close(true, false, true);
                        }
                    });
                }
            },

            requestStart: function () {
                TS.UI.Mask.show();
            },

            requestEnd: function () {
                TS.UI.Mask.hide();
            },

            //endregion

            //region (get)setData

            _getData: function () {
                var me = this,
                    result = me.parent();

                result.Filters = {};
                $.each(me.Filters, function (fltName, filter) {
                    var displayValue = TS.unwrap(filter.DisplayValue);
                    if (displayValue) {
                        result.Filters[fltName] = {
                            Value: TS.unwrap(filter.Value),
                            DisplayValue: displayValue
                        };
                    } else {
                        result.Filters[fltName] = TS.unwrap(filter.Value);
                    }
                });
                return result;
            },

            _setData: function (data) {
                var me = this;

                me.parent(data);
                me.updateFilters(data.Filters);
            },

            //endregion

        });

    TS.domain.RecordListDomain.resetFullTextSearchOnFilter = true;

})();

kendo.data.DataReader.fn.errors = function (response) {
    if (viewModel && response.success === false) {
        var notifications = TS.Util.getNotifications(response);
        viewModel._showNotifications(notifications, response.messages);
        return true;
    }
    return false;
};